import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Sarah', 'Jennifer', 'Rachel', 'Amanda', 'Emily', 'Jessica', 'Michael', 'David', 'Ashley', 'Megan', 'Laura', 'Brian', 'Nicole', 'Kevin', 'Hannah', 'Ryan', 'Olivia', 'Daniel', 'Sophia', 'Ethan'];
const COUNTRIES = ['New York 🇺🇸', 'London 🇬🇧', 'Toronto 🇨🇦', 'Sydney 🇦🇺', 'Los Angeles 🇺🇸', 'Chicago 🇺🇸', 'Manchester 🇬🇧', 'Melbourne 🇦🇺', 'Dublin 🇮🇪', 'Auckland 🇳🇿', 'Vancouver 🇨🇦', 'Boston 🇺🇸', 'Austin 🇺🇸', 'Seattle 🇺🇸', 'Birmingham 🇬🇧', 'Brisbane 🇦🇺', 'Calgary 🇨🇦', 'Denver 🇺🇸', 'Phoenix 🇺🇸', 'Edinburgh 🇬🇧'];
const PRODUCT = 'Little Genius System™';
export function SocialProofPopup() {
  const [mounted, setMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    country: ''
  });
  useEffect(() => {
    const mountTimer = setTimeout(() => setMounted(true), 4000);
    return () => clearTimeout(mountTimer);
  }, []);
  useEffect(() => {
    if (!mounted) return;
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setCurrentPurchase({
        name: randomName,
        country: randomCountry
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimer = setTimeout(showPopup, 1000);
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [mounted]);
  if (!mounted) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-[280px] md:max-w-sm rounded-lg shadow-lg p-3 md:p-4 flex items-start gap-2 md:gap-3 transition-all duration-300 bg-white border border-gray-200" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateX(0)' : 'translateX(-120%)',
    pointerEvents: isVisible ? 'auto' : 'none',
    contain: 'layout style'
  }} data-id="element-258">
      <div className="mt-0.5 flex-shrink-0" data-id="element-259">
        <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500" data-id="element-260" />
      </div>
      <div data-id="element-261">
        <p className="text-xs md:text-sm text-gray-800" data-id="element-262">
          <span className="font-bold" data-id="element-263">{currentPurchase.name}</span> from{' '}
          <span className="font-bold" data-id="element-264">{currentPurchase.country}</span> just
          purchased
        </p>
        <p className="text-xs md:text-sm font-bold mt-1 text-blue-600" data-id="element-265">
          {PRODUCT} 💙
        </p>
        <p className="text-[10px] md:text-xs text-gray-400 mt-0.5" data-id="element-266">
          A few seconds ago
        </p>
      </div>
    </div>;
}